export default "__VITE_ASSET__ed3294ad__"